import React, { PureComponent } from 'react';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import { Cell, BodyRow } from '../../../RoTable';

import { TooltipProperties, RoMapItem } from '@ro-atoms/RoTooltip/RoTooltip.types';
import { SpIconWrapper, ValidTo, WarningText } from '@ro-atoms/RoTooltip/RoTooltip.styles';
import { LocationDescriptorObject } from 'history';
import Icon from '@ro-atoms/Icon';
import { WARNINGS_FORMAT } from '@ro-utils/constant';
import moment from 'moment';

const shortProviderTypes: { [key: string]: string } = {
  estofex: 'E',
  skypredict: 'SP'
};

interface Props extends RouteComponentProps {
  tooltipProps: TooltipProperties;
}

export class WarningsComponent extends PureComponent<Props> {
  pushUrl = (row: RoMapItem) => () => {
    return this.props.history.push({
      pathname: '/centrum-ostrzezen',
      state: row,
      symbol: shortProviderTypes[row.UIType],
      provider: row.UIType,
      type: row.UIType
    } as LocationDescriptorObject);
  };
  render() {
    const { tooltipProps } = this.props;
    return tooltipProps
      ? Object.keys(tooltipProps.polygons).map(item => {
          const row = tooltipProps.polygons[item];
          return (
            <BodyRow clickable hoverable key={uuid()} onClick={this.pushUrl(row)}>
              <Cell maxWidth={200}>
                <SpIconWrapper bg={row.color} size={30}>
                  <Icon weather name={row.icon} />
                </SpIconWrapper>
                <b>{`${shortProviderTypes[row.UIType]}: ${row.title}`}</b>
              </Cell>
              <Cell maxWidth={200} noEllipsis>
                <WarningText>{row.shortDesc}</WarningText>
                {row.validFrom && row.validTo && (
                  <ValidTo>
                    ({moment.unix(row.validFrom).format(WARNINGS_FORMAT)} do{' '}
                    {moment.unix(row.validTo).format(WARNINGS_FORMAT)})
                  </ValidTo>
                )}
              </Cell>
            </BodyRow>
          );
        })
      : null;
  }
}

export const Warnings = withRouter(WarningsComponent);
